import { render, staticRenderFns } from "./resetpassword.vue?vue&type=template&id=dd866404&scoped=true"
import script from "./resetpassword.vue?vue&type=script&lang=js"
export * from "./resetpassword.vue?vue&type=script&lang=js"
import style0 from "./resetpassword.vue?vue&type=style&index=0&id=dd866404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd866404",
  null
  
)

export default component.exports